import ButtonBase from '@mui/material/ButtonBase';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import KmxArrowRightStroked from '@kmx/mui-icons/KmxArrowRightStroked';
import KmxLightbulbStroked from '@kmx/mui-icons/KmxLightbulbStroked';

interface IResearchArticlesTileProps {
    itemIndex: number;
    content: IResearchPrompt;
}

export interface IResearchPrompt {
    type: 'PROMPT';
    heading: string;
    buttonLabel: string;
}

const ResearchArticlesPrompt = ({ itemIndex }: IResearchArticlesTileProps) => (
    <ButtonBase href="/research" aria-label={'Visit research view all research'} data-index={itemIndex}>
        <Paper
            elevation={0}
            className="carousel-slide-item"
            sx={{
                border: '1px solid var(--elevation-outlined, #CCD0D6)',
                padding: 1,
                display: { xs: 'flex', md: 'none' },
                flexDirection: 'column',
                justifyContent: 'center',
                flex: '1 0 0',
                alignSelf: 'stretch',
                height: '18rem',
                width: '12.5rem',
            }}
        >
            <Button variant="text" color="secondary" endIcon={<KmxArrowRightStroked />}>
                Visit research
            </Button>
        </Paper>
        <Paper
            elevation={0}
            sx={{
                padding: 5,
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                border: '1px solid var(--elevation-outlined, #CCD0D6)',
                height: '19.688rem',
                width: '18rem',
            }}
            className="carousel-slide-item"
        >
            <Stack gap={3}>
                <Stack>
                    <Box>
                        <KmxLightbulbStroked sx={{ fontSize: '56px' }} />
                    </Box>
                    <Typography variant="h5">Want to learn more about our best-sellers?</Typography>
                </Stack>
                <Button color="primary" variant="outlined" size="medium">
                    Visit Research
                </Button>
            </Stack>
        </Paper>
    </ButtonBase>
);

export default ResearchArticlesPrompt;
